/* RomartaLux — carusel manual pentru sectiunea "Alege categoria" (homepage).
   Fara autoplay si fara loop: se muta doar la swipe/scroll sau la click pe sageti. */
(function () {
  /* Sectiunile dintr-un template JSON primesc id-ul `shopify-section-template--<id>__<cheie>`,
     deci ne agatam de sufixul cheii, nu de un id fix. */
  var SECTION_SELECTOR = '[id^="shopify-section-"][id$="__categorii"]';
  var TRACK_SELECTOR = '.section-content-wrapper > .group-block > .group-block-content';
  var TOLERANCE = 4;

  function makeButton(direction, label) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'rtx-cat-arrow rtx-cat-arrow--' + direction;
    button.setAttribute('aria-label', label);
    button.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M15 4 7 12l8 8" fill="none" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return button;
  }

  function step(track, slides) {
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return slides[0].getBoundingClientRect().width + gap;
  }

  function init(root) {
    var scope = root || document;
    var section = scope.querySelector(SECTION_SELECTOR);
    if (!section && scope.matches && scope.matches(SECTION_SELECTOR)) section = scope;
    if (!section) return;

    var track = section.querySelector(TRACK_SELECTOR);
    if (!track || track.dataset.rtxCarousel === 'true') return;

    var slides = track.querySelectorAll(':scope > .group-block');
    if (slides.length < 2) return;

    track.dataset.rtxCarousel = 'true';

    var host = track.parentElement;
    host.classList.add('rtx-cat-carousel');

    var prev = makeButton('prev', 'Categoria anterioara');
    var next = makeButton('next', 'Categoria urmatoare');
    host.appendChild(prev);
    host.appendChild(next);

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function update() {
      var max = maxScroll();
      prev.disabled = track.scrollLeft <= TOLERANCE;
      next.disabled = track.scrollLeft >= max - TOLERANCE;
      host.classList.toggle('rtx-cat-carousel--static', max <= TOLERANCE);
    }

    /* Ultimul pas inghite si restul de sub jumatate de card, ca sa nu ramana
       un "slide fantoma" care doar aliniaza ultima poza. */
    function slide(direction) {
      var amount = step(track, slides);
      var max = maxScroll();
      var target = track.scrollLeft + direction * amount;

      if (direction > 0 && max - target < amount / 2) target = max;
      if (direction < 0 && target < amount / 2) target = 0;

      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () {
      slide(-1);
    });

    next.addEventListener('click', function () {
      slide(1);
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update);
    }

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
